<template>
    <span :class="['status-label', 'payment', statusName, size]">
        <span class="text">
            <span>{{ statusTxt }}</span>
            <span v-if="count !== null" class="count">{{ count }}</span>
            <el-tooltip v-if="isTempSaved" class="item" size="small" effect="dark" content="已暫存付款明細" placement="top">
                <img
                    src="@/assets/img/green_check.svg"
                    alt=""
                    style="
                        width: 17px;
                        vertical-align: middle;
                        margin-right: -5px;
                    "
                />
            </el-tooltip>
            <el-tooltip v-if="isPayInFuture" class="item" size="small" effect="dark" content="預約付款" placement="top">
                <img
                    src="@/assets/img/payment-future-icon.svg"
                    alt=""
                    style="
                        width: 17px;
                        vertical-align: middle;
                        margin-right: -5px;
                    "
                />
            </el-tooltip>
        </span>
    </span>
</template>

<script>
import _ from 'lodash';
import { paymentStatus } from '@/assets/commonData/options';

export default {
    name: 'payment-status-label',
    props: {
        statusNum: {
            type: Number,
            default: () => 0,
        },
        count: {
            type: Number,
            default: () => null,
        },
        size: {
            type: String,
            dafault: () => 'normal',
        },
        isTempSaved: {
            type: Boolean,
            dafault: () => false,
        },
        isPayInFuture: {
            type: Boolean,
            dafault: () => false,
        },
    },
    computed: {
        statusTxt() {
            return _.find(paymentStatus, ['key', this.statusNum])?.value;
        },
        statusName() {
            return _.find(paymentStatus, ['key', this.statusNum])?.name;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.payment.status-label {
    display: inline-block;
    height: 26px;
    line-height: 26px;
    padding: 0 10px;
    border-radius: 13px;
    background-color: #eee;

    > .text {
        font-size: 9.5pt;
        font-weight: 500;

        .count {
            opacity: 0.5;
            margin-left: 7px;
            font-weight: bold;
        }
    }

    &.pending {
        background-color: #ffe36c;
        color: #4d2c06;
    }

    &.wait-for-pay {
        background-color: #463cb2;
        color: #fff;
    }

    &.wait-for-confirm {
        background-color: #dae0ff;
        color: #1f3190;
    }

    &.done {
        background-color: #def5d6;
        color: #0baa1b;
    }

    &.reject {
        background-color: #ffe8e8;
        color: #ff2c2c;
    }

    &.cancel {
        background-color: #f4f4f4;
        color: #848484;
    }
}
</style>
